import { visuallyHiddenStyles } from "@newsela/angelou";

export const popOutCss = {
  root: { zIndex: 3 },
};

export const labelHeaderCss = {
  root: { ...visuallyHiddenStyles },
};

export const fieldCss = {
  root: {
    maxWidth: "296px",
  },
};

export const scheduleSectionCss = {
  paddingTop: "24px",
};

export const errorCss = {
  root: { height: "12px" },
};
